import styled from "@emotion/styled";
import { fontBarlowSemiCondensed, fontPlayfairDisplay } from "@product/scmp-sdk";

import {
  Container as FloatClickableAreaContainer,
  SwipeLeftArea,
  SwipeRightArea,
} from "~/components/story-style/story-style-float-clickable-area/styles";

import EmailLogo from "./email-logo.svg";

export const Container = styled.div`
  position: relative;

  inline-size: 100%;
  block-size: 100%;

  background-color: #fdfdfd;

  ${FloatClickableAreaContainer} {
    position: absolute;
    z-index: 3;

    inline-size: 25%;
  }

  ${SwipeLeftArea} {
    inline-size: 100%;
  }

  ${SwipeRightArea} {
    display: none;
  }
`;

export const ContentContainer = styled.div`
  position: fixed;
  inset-inline-start: 0;
  z-index: 2;

  display: flex;
  flex-direction: column;

  inline-size: 100%;
  inline-size: 100%;
  block-size: 100%;
  min-block-size: fill-available;
  padding-block-start: 127px;
  padding-inline: 30px;

  ${props => props.theme.breakpoints.up("tablet")} {
    position: absolute;
  }
`;

export const ButtonContainer = styled.div`
  position: fixed;
  inset-inline-start: 0;
  z-index: 2;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  inline-size: 100%;
  inline-size: 100%;
  block-size: 100%;
  min-block-size: fill-available;

  ${props => props.theme.breakpoints.up("tablet")} {
    position: absolute;
  }
`;

export const StyledEmailLogo = styled(EmailLogo)`
  inline-size: 31px;
  block-size: 23px;
`;

export const StyledTitle = styled.div`
  color: #222222;
  font-weight: 400;
  font-size: 28px;
  font-family: ${fontPlayfairDisplay};
  font-style: normal;
  line-height: 32px;
`;

export const StyledSubTitle = styled.div`
  margin-block-start: 16px;

  font-weight: 400;
  font-size: 16px;
  font-family: ${fontPlayfairDisplay};
  font-style: normal;
  line-height: 28px;
  text-transform: uppercase;
`;

export const Link = styled.a`
  position: absolute;
  inset-block-end: 24px;
`;

export const StyledSignUpButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 120px;
  block-size: 33px;

  font-weight: 600;
  font-size: 14px;
  font-family: ${fontBarlowSemiCondensed};
  font-style: normal;
  line-height: 17px;
  letter-spacing: 0.1em;
  text-transform: uppercase;

  border: 1px solid #ffffff;
  border-radius: 2px;

  background: #ffffff;
`;

export const BackgroundContainer = styled.div`
  position: absolute;
  inset-inline-start: 0;

  inline-size: 100%;
  block-size: 100%;
`;

export const GradientOverlay = styled.div`
  position: absolute;
  inset-block-start: 0;

  inline-size: 100%;
  block-size: 75px;

  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);

  mix-blend-mode: multiply;

  opacity: 0.3;
  transform: matrix(1, 0, 0, -1, 0, 0);
`;

export const StyledImage = styled.img`
  position: absolute;
  inset-block-end: 0;
  inset-inline-end: 0;

  inline-size: 100%;
`;
